/* tslint:disable */
/* eslint-disable */
/**
 * Alobacsi API
 * The Alobacsi API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Province
 */
export interface Province {
    /**
     * 
     * @type {string}
     * @memberof Province
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Province
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof Province
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof Province
     */
    nameWithType: string;
    /**
     * 
     * @type {string}
     * @memberof Province
     */
    code: string;
}

/**
 * Check if a given object implements the Province interface.
 */
export function instanceOfProvince(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "slug" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "nameWithType" in value;
    isInstance = isInstance && "code" in value;

    return isInstance;
}

export function ProvinceFromJSON(json: any): Province {
    return ProvinceFromJSONTyped(json, false);
}

export function ProvinceFromJSONTyped(json: any, ignoreDiscriminator: boolean): Province {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'slug': json['slug'],
        'type': json['type'],
        'nameWithType': json['nameWithType'],
        'code': json['code'],
    };
}

export function ProvinceToJSON(value?: Province | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'slug': value.slug,
        'type': value.type,
        'nameWithType': value.nameWithType,
        'code': value.code,
    };
}

